import {
  mainBackend,
  quizBackendService,
  authBackend,
  lmsBackend
} from "../../../environment/environment";
import storageService from "../services/storage-service";

function getRequestHeaders() {
  return {
    uid: storageService.get("uid"),
    Authorization: storageService.get("authorization"),
  };
}

class ApiService {
  get(data) {
    if (data.server === "main") {
      return mainBackend.request({
        headers: getRequestHeaders(),
        method: "get",
        url: data.url,
        params: data.params
      });
    } else if (data.server === "lms") {
      return lmsBackend.request({
        headers: getRequestHeaders(),
        method: "get",
        url: data.url,
        params: data.params
      });
    } else {
      return quizBackendService.request({
        headers: getRequestHeaders(),
        method: "get",
        url: data.url,
        params: data.params
      });
    }
  }
  post(data) {
    if (data.server === "main") {
      return mainBackend.request({
        headers: getRequestHeaders(),
        method: "post",
        url: data.url,
        data: data.body
      });
    } else if (data.server === "auth") {
      return authBackend.request({
        headers: getRequestHeaders(),
        method: "post",
        url: data.url,
        data: data.body
      });
    } else {
      return quizBackendService.request({
        headers: getRequestHeaders(),
        method: "post",
        url: data.url,
        data: data.body,
        onUploadProgress: data.config
      });
    }
  }
  put(data) {
    if (data.server === "main") {
      return mainBackend.request({
        headers: getRequestHeaders(),
        method: "put",
        url: data.url,
        data: data.body
      });
    } else {
      return quizBackendService.request({
        headers: getRequestHeaders(),
        method: "put",
        url: data.url,
        data: data.body
      });
    }
  }
  delete(data) {
    if (data.server === "main") {
      return mainBackend.request({
        headers: getRequestHeaders(),
        method: "delete",
        url: data.url
      });
    } else {
      return quizBackendService.request({
        headers: getRequestHeaders(),
        method: "delete",
        url: data.url,
        data: data.body
      });
    }
  }
}
export default new ApiService();
